function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h40v26H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F06022",
  d: "M16.13 19.29h7.74V6.7h-7.74v12.58z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#EA1D25",
  d: "M16.93 13A7.93 7.93 0 0120 6.71a8.02 8.02 0 00-10.65.65 7.96 7.96 0 000 11.28 8.02 8.02 0 0010.65.65A8.02 8.02 0 0116.93 13"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F79D1D",
  d: "M33 13c0 2.12-.84 4.15-2.34 5.65a8.1 8.1 0 01-10.66.64A8.05 8.05 0 0023.07 13 7.96 7.96 0 0020 6.71a8.02 8.02 0 0110.66.64A7.93 7.93 0 0133 13"
});

function SvgMc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = React.forwardRef(SvgMc);
export default __webpack_public_path__ + "static/media/mc.a75f5965.svg";
export { ForwardRef as ReactComponent };